module.exports = __webpack_public_path__ + "static/media/li1.3061bd62.jpg";